import React, { useContext } from 'react';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import { ButtonComponent } from '../../../base/button/Button';
import { AnimatedStack } from '../../../MotionMui/MotionMui';
import { WorldTourContext } from './WorldTourContext';
import { WorldTourTeamCard } from './WorldTourTeamCard';

export interface LeagueUrlParams {
  teamId: string;
  regionId: string;
  leagueId: string;
}
export const WorldTourLeagueHome = () => {
  const leagueUrlParams = useParams<LeagueUrlParams>();
  const worldTourContext = useContext(WorldTourContext);
  const history = useHistory();

  const teams = worldTourContext
    .getCollection()
    .leagues[
      `${leagueUrlParams.regionId}/${leagueUrlParams.leagueId}`
    ].teams.map((team) => {
      return <WorldTourTeamCard {...team} />;
    });
  return (
    <Switch>
      <Route exact path="/teams/:teamId/play/world-tour/:regionId/:leagueId">
        <AnimatedStack staggerSpeed={'Fast'} spacing={2}>
          {teams}
          <ButtonComponent
            onClick={() => {
              history.push(
                `/teams/${leagueUrlParams.teamId}/play/world-tour/${leagueUrlParams.regionId}`
              );
              worldTourContext.setLastLeagueId(undefined);
            }}
          >
            Back to league select
          </ButtonComponent>
        </AnimatedStack>
      </Route>
    </Switch>
  );
};
